import { get, post, put } from '../../../api';

export const getTemplateGrupos = () => {
  return get('/api/conectores/template/grupos');
};

export const getTemplateGrupo = (id) => {
  return get(`/api/conectores/template/grupo/${id}`);
};

export const postTemplateGrupo = (data) => {
  return post('/api/conectores/template/grupo', data);
};

export const putTemplateGrupo = (data) => {
  return put('/api/conectores/template/grupo', data);
};
